<template>
  <v-form ref="SALARIE_CIVILITE" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="SALARIE_CIVILITE">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <salarie-nom-naissance v-if="isDisplayed('NOM_NAISSANCE')"
                               ref="NOM_NAISSANCE"
                               :theme="theme"
                               :showMissing="showMissing"
                               v-model:value=nomNaissance
                               :min="3"
                               :max="25"
                               @status=statusNomNaissance
                               :over-ride-placeholder=placeholderNomNaissance
                               :required="isRequired('NOM_NAISSANCE')"
                               :contextId=salarie.id
                               :readOnly="readOnly('NOM_NAISSANCE')"
                               :objType=objType
                               :fiche=fiche
                               :sectionName="sectionName">
        </salarie-nom-naissance>
        <salarie-date-naissance v-if="isDisplayed('DATE_NAISSANCE')"
                                ref="DATE_NAISSANCE"
                                :theme="theme"
                                :showMissing="showMissing"
                                v-model:value=dateNaissance
                                @status=statusDateNaissance
                                :periods='periodDateNaissance'
                                :required="isRequired('DATE_NAISSANCE')"
                                :contextId=salarie.id
                                :readOnly="readOnly('DATE_NAISSANCE')"
                                :objType=objType
                                :fiche=fiche
                                :sectionName="sectionName">
        </salarie-date-naissance>
        <salarie-ville-naissance v-if="isDisplayed('VILLE_NAISSANCE')"
                                 ref="VILLE_NAISSANCE"
                                 :theme="theme"
                                 :showMissing="showMissing"
                                 v-model:value=villeNaissance
                                 :min="3"
                                 :max="25"
                                 @status=statusVilleNaissance
                                 :over-ride-placeholder=placeholderVilleNaissance
                                 :required="isRequired('VILLE_NAISSANCE')"
                                 :contextId=salarie.id
                                 :readOnly="readOnly('VILLE_NAISSANCE')"
                                 :objType=objType
                                 :fiche=fiche
                                 :sectionName="sectionName">
        </salarie-ville-naissance>
        <salarie-departement-naissance v-if="isDisplayed('DEPARTEMENT_NAISSANCE')"
                                       ref="DEPARTEMENT_NAISSANCE"
                                       :theme="theme"
                                       :showMissing="showMissing"
                                       v-model:value=departementNaissance
                                       :min="1"
                                       :max="3"
                                       @status=statusDepartementNaissance
                                       :over-ride-placeholder=placeholderDepartementNaissance
                                       :required="isRequired('DEPARTEMENT_NAISSANCE')"
                                       :contextId=salarie.id
                                       :readOnly="readOnly('DEPARTEMENT_NAISSANCE')"
                                       :objType=objType
                                       :fiche=fiche
                                       :sectionName="sectionName">
        </salarie-departement-naissance>
        <pays-select v-if="isDisplayed('PAYS_NAISSANCE_ID')"
                     ref="PAYS_NAISSANCE_ID"
                     :theme="theme"
                     :showMissing="showMissing"
                     v-model:value=paysNaissanceId
                     :moduleId=moduleId
                     libelle="'Pays de naissance'"
                     newLabel=''
                     selectText=""
                     @status=statusPaysNaissanceId
                     :requiredAttributs="requiredAttributs"
                     :autoSelect=true
                     :ressource=ressourcePaysSelect
                     :filters=paysNaissanceIdFilter
                     :toggleReset=resetPaysNaissanceId
                     :required="isRequired('PAYS_NAISSANCE_ID')"
                     :contextId=salarie.id
                     :readOnly="readOnly('PAYS_NAISSANCE_ID')"
                     :objType=objType
                     :fiche=fiche
                     :sectionName="sectionName">
        </pays-select>
        <pays-select-nat v-if="isDisplayed('PAYS_NATIONALITE_ID')"
                         ref="PAYS_NATIONALITE_ID"
                         :theme="theme"
                         :showMissing="showMissing"
                         v-model:value=paysNationaliteId
                         :moduleId=moduleId
                         libelle="'Nationalité'"
                         newLabel=''
                         selectText=""
                         @status=statusPaysNationaliteId
                         :requiredAttributs="requiredAttributs"
                         :autoSelect=true
                         :ressource=ressourcePaysSelectNat
                         :filters=paysNationaliteIdFilter
                         :toggleReset=resetPaysNationaliteId
                         :required="isRequired('PAYS_NATIONALITE_ID')"
                         :contextId=salarie.id
                         :readOnly="readOnly('PAYS_NATIONALITE_ID')"
                         :objType=objType
                         :fiche=fiche
                         :sectionName="sectionName">
        </pays-select-nat>
        <salarie-numero-secu v-if="isDisplayed('NUMERO_SECU')"
                             ref="NUMERO_SECU"
                             :theme="theme"
                             :showMissing="showMissing"
                             v-model:value=numeroSecu
                             @status=statusNumeroSecu
                             :over-ride-placeholder=placeholderNumeroSecu
                             :required="isRequired('NUMERO_SECU')"
                             :contextId=salarie.id
                             :readOnly="readOnly('NUMERO_SECU')"
                             :objType=objType
                             :fiche=fiche
                             :sectionName="sectionName">
        </salarie-numero-secu>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudSalarie from '@/generated/cruds/CrudSalarie';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudSalarie,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.SALARIE_CIVILITE,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        placeholderNomNaissance: null,
        placeholderVilleNaissance: null,
        placeholderDepartementNaissance: null,
        placeholderNumeroSecu: null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },

      ressourcePaysSelect () { return RessourceGenControl(GenControl.SALARIE_CIVILITE_PAYS_SELECT); },
      ressourcePaysSelectNat () { return RessourceGenControl(GenControl.SALARIE_CIVILITE_PAYS_SELECT_NAT); },

      ressource () { return RessourceGenSection(GenSection.SALARIE_CIVILITE); },

      fields (): string[] {
        return ['NOM_NAISSANCE', 'DATE_NAISSANCE', 'VILLE_NAISSANCE', 'DEPARTEMENT_NAISSANCE', 'PAYS_NAISSANCE_ID', 'PAYS_NATIONALITE_ID', 'NUMERO_SECU'];
      },

      extraButtons (): Button[] {
        return [];
      },

      paysNaissanceIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
      paysNationaliteIdFilter (): ColumnFilter[] {
        const res: ColumnFilter[] = [];
        return res;
      },
    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editSalarie.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("NOM_NAISSANCE", false);
          this.readOnlyMap.set("DATE_NAISSANCE", false);
          this.readOnlyMap.set("VILLE_NAISSANCE", false);
          this.readOnlyMap.set("DEPARTEMENT_NAISSANCE", false);
          this.readOnlyMap.set("PAYS_NAISSANCE_ID", false);
          this.readOnlyMap.set("PAYS_NATIONALITE_ID", false);
          this.readOnlyMap.set("NUMERO_SECU", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("NOM_NAISSANCE", this.requiredMissing(requiredAttributs, "NOM_NAISSANCE") || !!this.fiche);
          this.displayMap.set("DATE_NAISSANCE", true);
          this.displayMap.set("VILLE_NAISSANCE", true);
          this.displayMap.set("DEPARTEMENT_NAISSANCE", true);
          this.displayMap.set("PAYS_NAISSANCE_ID", true);
          this.displayMap.set("PAYS_NATIONALITE_ID", true);
          this.displayMap.set("NUMERO_SECU", true);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("NOM_NAISSANCE", this.requiredMissing(requiredAttributs, "NOM_NAISSANCE") || !this.fiche);
          this.requiredMap.set("DATE_NAISSANCE", true);
          this.requiredMap.set("VILLE_NAISSANCE", true);
          this.requiredMap.set("DEPARTEMENT_NAISSANCE", true);
          this.requiredMap.set("PAYS_NAISSANCE_ID", true);
          this.requiredMap.set("PAYS_NATIONALITE_ID", true);
          this.requiredMap.set("NUMERO_SECU", true);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoCivilite' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
